import React, {useEffect, useState} from "react";
import prevBtn from "../Content/GamesCatalog/Icon Frame (1).png";
import nextBtn from "../Content/GamesCatalog/Icon Frame (2).png";

const Fullscreen = ({ closeFullscreen, selectedConsole, currentImageIndex, nextImage, prevImage }) => {
    const [startTouch, setStartTouch] = useState(null);

    useEffect(() => {
        if (!selectedConsole) {
            return
        }
        const handleKeyDown = (e) => {
            if (e.key === "ArrowRight") {
                nextImage();
            }
            if (e.key === "ArrowLeft") {
                prevImage();
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [selectedConsole]);


    if (!selectedConsole) return null;

    const handleOverlayClick = () => closeFullscreen();


    const handleNextClick = (e) => {
        e.stopPropagation();
        nextImage();


    };

    const handlePrevClick = (e) => {
        e.stopPropagation();
        prevImage();
    };

    const handleTouchStart = (e) => setStartTouch(e.touches[0].clientX);

    const handleTouchEnd = (e) => {
        const touchEnd = e.changedTouches[0].clientX;
        if (startTouch !== null) {
            const diff = startTouch - touchEnd;
            if (diff > 50) nextImage();
            else if (diff < -50) prevImage();
        }
    };
    return (
        <div className="fullscreen-overlay" onClick={handleOverlayClick} onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd}>
            <img src={selectedConsole.image[currentImageIndex]}  onClick={(e) => e.stopPropagation()} className="fullscreen-image" alt="fullscreen" />
            <button className="next" onClick={handleNextClick}>
                <img src={nextBtn} alt="next" />
            </button>
            <button className="previous" onClick={handlePrevClick}>
                <img src={prevBtn} alt="prev" />
            </button>
        </div>
    );
};

export default Fullscreen;